module.exports = __webpack_public_path__ + "static/media/premium.951f1b4f.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/sidebar/premium.svg
// module id = 1031
// module chunks = 0